.ux-scrollable-container {
  background: $color-white;
  display: block;
  overflow: hidden;
  position: relative;
  z-index: 2;

  &__track {
    background: $color-black-70;
    border-radius: 30px;
    cursor: grab;
    display: block;
    height: 10px;
  }

  [data-scroll-target],
  &__scroll {
    /* IE10+ */
    -ms-overflow-style: -ms-autohiding-scrollbar;
    overflow-x: auto;

    /* FireFox */
    scrollbar-width: none;

    &::-webkit-scrollbar {
      /* Chrome, Safari, Edge */
      display: none;
    }
  }

  &--top {
    margin-bottom: 5px;
  }

  &--bottom {
    margin-top: 5px;
  }
}
